/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

 import { apiFetch } from '../../../apiClient';
 import { getSessionDatas, loadLanguage } from '../../../utils';
 import { apiMap, settings } from '../../../config/constants';
 import { showLoaing, saveStatus } from '../../App/state/action';

export const skipUploadAction = data => ({
    type: 'IS_SKIP_UPLOAD',
    data
})
export const sumbitApplication = () => dispatch => {
    dispatch(showLoaing(true));
    const { applicationId } = getSessionDatas();
    const lan = loadLanguage().split('-')[0];
    const sumbitApplicationParams = {
        hostname: settings.hostnameSubmit,
        paramsObj: {
            applicationId,
            lan
        },
        method: settings.post,
    };
    return apiFetch(apiMap.submitApp, sumbitApplicationParams)(dispatch)
                .then(res => {
                    dispatch(showLoaing(false));
                    dispatch(saveStatus({"status": 2}));
                    return res;
                })
                .catch(error => {
                    dispatch(showLoaing(false));
                    dispatch(saveStatus({"status": 2}));
                    throw error;
                });
 }

 /* istanbul ignore next */
export const getStatusFile = (documentId) => dispatch =>{
    const uploadFileParams = {
        hostname: settings.hostnameStatusUploadFile,
        headers: {
            ...settings.clientHeaders
        }
    }
    return apiFetch(apiMap.getStatusFile(documentId),uploadFileParams)(dispatch)
                .then((response) => {
                    if (response && response.documents){
                        return response.documents;
                    }
                }).catch((e) => {
                    throw e;
                })
};

export const saveUploadBusiness = (section) => (dispatch) => {
    const { applicationId } = getSessionDatas();
    const updateBusinessParams = {
        hostname: settings.hostBusiness,
        paramsObj: {
            businessInfo: {
                appId: applicationId,
                ...section
            }
        },
        method: settings.put,
    };
    return apiFetch(apiMap.updateBusiness, updateBusinessParams)(dispatch)
                .then(res => {
                    return res;
                })
                .catch(error => {
                    throw error;
                })
 }


// WEBPACK FOOTER //
// ./src/views/AOFormReview/state/action.js